import { defineComponent as _defineComponent } from 'vue'
import global from '../static/singleton'
import { routeQueue } from '@/router'
import { secondaryDrawerIcon, secondaryDrawerOnClick, secondaryDrawerTooltip } from '@/helpers/drawer.helper'
import { isTestStudy } from '@/helpers/singleton.helper'
import Banner from './Banner.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBar',
  props: {
    maintenanceMode: { type: Boolean },
    serverMode: null,
    showBanner: { type: Boolean }
  },
  setup(__props: any) {



function toStudySelector () {
  routeQueue.pushAndReturnToCurrent({ name: 'StudySelector' })
}

function toLocaleSelector () {
  routeQueue.pushAndReturnToCurrent({ name: 'LocaleSelector' })
}


return { __sfc: true,toStudySelector, toLocaleSelector, global, secondaryDrawerIcon, secondaryDrawerOnClick, secondaryDrawerTooltip, isTestStudy, Banner }
}

})